import styled from 'styled-components';
import { media } from '../../../ui';
export const Container = styled.div.withConfig({
  displayName: "Style__Container",
  componentId: "sc-1rvczuh-0"
})(["", " ", ""], media.sm`
    width: 100%;
    height: 80px;
    border-radius: 6px;
  `, media.xs`
    height: 72px;
  `);
export const Footer = styled.div.withConfig({
  displayName: "Style__Footer",
  componentId: "sc-1rvczuh-1"
})(["padding:0 0 30px;text-align:right;button{height:60px;font-size:", "px;", " ", "}"], ({
  theme: {
    fontSize
  }
}) => fontSize.lg, media.sm`
      width: 100%;
      height: 80px;
      font-size: ${({
  theme: {
    fontSize
  }
}) => fontSize.h6}px;
      border-radius: 6px;
    `, media.xs`
      height: 72px;
    `);